module.exports = __webpack_public_path__ + "img/profile-4.19704aca.png";